__webpack_require__.p = "/mi-assets/mi-static/mi-shop-renderer-2/web-rel-26.3.2-0325262pm/_next/";